(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaf-hero-mark"] && !Shopify.designMode) return;
  try {
    
  /* KAF Morse Rail — lights up dot-by-dot as user scrolls the page.
     Only visible after the hero (body.kaf-past-hero). Color flips
     automatically when rail crosses a dark section. */
  (function () {
    var body    = document.body;
    var rail    = document.getElementById('kafMorseRail');
    var rects   = rail ? rail.querySelectorAll('rect') : [];
    var counter = document.getElementById('kafMorseRailCount');
    var darkSel = '.kaf-campaign, .kaf-manifesto, footer';

    function updateRail () {
      if (!body.classList.contains('kaf-past-hero')) {
        rects.forEach(function(r){ r.classList.remove('is-lit'); });
        if (counter) counter.textContent = '0/9';
        body.classList.remove('kaf-rail-on-dark');
        return;
      }

      var hero     = document.querySelector('.kaf-hero-mark');
      var heroH    = hero ? hero.offsetHeight : window.innerHeight;
      var docH     = document.documentElement.scrollHeight;
      var winH     = window.innerHeight;
      var remaining = Math.max(1, docH - winH - heroH);
      var trail    = Math.max(0, Math.min(1, (window.scrollY - heroH) / remaining));

      var litCount = 0;
      rects.forEach(function(r) {
        var tk  = parseFloat(r.getAttribute('data-tk'));
        var lit = trail >= tk - 0.02;
        r.classList.toggle('is-lit', lit);
        if (lit) litCount++;
      });
      if (counter) counter.textContent = litCount + '/9';

      /* Flip color when rail sits over a dark section */
      var railY      = window.innerHeight * 0.5;
      var darkEls    = document.querySelectorAll(darkSel);
      var onDark     = false;
      darkEls.forEach(function(el) {
        var rect = el.getBoundingClientRect();
        if (rect.top <= railY && rect.bottom >= railY) onDark = true;
      });
      body.classList.toggle('kaf-rail-on-dark', onDark);
    }

    window.addEventListener('scroll',  updateRail, { passive: true });
    window.addEventListener('resize',  updateRail, { passive: true });
    requestAnimationFrame(updateRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
